
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class AgeAtFirstDiagnosisCount extends Vue {
  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("ageAtFirstDiagnosisCount");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("ageAtFirstDiagnosisCount");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
